// Product Review extension (admin side): the publish workflow of a catalog
// product — the organization sends it for review, the platform admin approves
// or rejects it. `publishStatus` itself is the product-info extension's
// field; this tab is only where it is decided.
//
// It owns no fields of its own; the server half only declares the id.
import { ShieldCheckIcon } from "@heroicons/react/24/outline"
import AdminReviewTab from "./AdminReviewTab"
import PublishStateSubtitle from "./PublishStateSubtitle"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { useVendorVisibilityContext } from "../shared/vendor-visibility"
import { reviewBadge } from "../shared/review-marks"

export const StoreProductExtension = {
  // the last tab: a product is read (Information opens the dialog) before it
  // is decided on. Its `order` is the highest of the extensions.
  id: "admin-review",
  label: "Product Review",
  description: "The publish workflow: send a product for review, approve or reject it",
  section: {
    component: catalogSection(AdminReviewTab),
    label: "Product Review",
    icon: ShieldCheckIcon,
    // what a reviewer marked here for the vendor (shared/review-marks)
    badge: reviewBadge("admin-review"),
    order: 1500,
    // an approved product has nothing left to send: a merchant no longer gets the
    // tab (Aldoo keeps it, to take a product back off the store)
    visible: (context) => !(context?.vendorEditor && context?.published) && catalogVisible("adminReview")(context),
  },
  provider: CatalogEditorProvider,
  // where the product stands, under the dialog's title, whatever tab is open
  subtitle: PublishStateSubtitle,
  visibilityContext: [useCatalogVisibilityContext, useVendorVisibilityContext],
}
